import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]

class ApolexDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Visita Tamaulipas' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                
                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--4"  data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">OPOSICIONES APOLEX</h2>
                                    <p>Cartas de memoria de la academia de oposiciones Apolex. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Portfolio Details */}
                <div className="rn-portfolio-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="portfolio-details">
                                    <div className="inner">
                                        <h2>Oposiciones Apolex</h2>
                                        <p className="subtitle">Cartas de memoria para una academia de oposiciones.</p>
                                        <p>Aplicación de gestión de los clientes de una academia con la funcionalidad de añadir diferentes bolsas de preguntas para facilitar el estudio a los usuarios. Los usuarios pueden contestar estas bolsas de preguntas con un tiempo limitado y rehacer las fallidas.</p>
                                        <p>Proyecto solicitado por la academia de oposiciones Apolex a finales de 2022.</p>

                                        <div className="portfolio-view-list d-flex flex-wrap">
                                            <div className="port-view">
                                                <span>Framework Frontend</span>
                                                <h4>React</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Framework Backend</span>
                                                <h4>Nest.js</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Lenguajes</span>
                                                <h4>Javascript/Typescript</h4>
                                            </div>
                                        </div>

                                    </div>
                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Details */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />  


            </React.Fragment>
        )
    }
}
export default ApolexDetails;
